import { useSelector } from 'react-redux'

import { selectFeatures, selectCanApplicationInsightsSort, selectAppRoundEditDisabled } from '.'

export const useHasFeature = (feature: string): boolean => !!useSelector(selectFeatures)[feature]
export const useCanSortApplicationInsights = (): boolean => useSelector(selectCanApplicationInsightsSort)
export const useAppRoundEditDisabled = (): boolean => useSelector(selectAppRoundEditDisabled)

export const useConfigureUpcomingApplicationCycle = (): boolean => useHasFeature('ConfigureUpcomingApplicationCycle')
